
import { css } from 'lit';
export default css`
/* Apply CSS Variables to the host element. */
:host{
  --sic-breadcrumb--default--display:flex;
  --sic-breadcrumb--default--background:transparent;
  --sic-breadcrumb--default--flex-direction:row;
  --sic-breadcrumb--default--flex-wrap:nowrap;
  --sic-breadcrumb--default--gap:var(--spacing-3);
  --sic-breadcrumb--default--padding:var(--spacing-06) var(--spacing-0);
  --sic-breadcrumb--default--margin:var(--spacing-02);
  --sic-breadcrumb--default--font-family:var(--ff-body);
  --sic-breadcrumb--default--font-size:14px;
  --sic-breadcrumb--default--font-weight:400;
  --sic-breadcrumb--default--line-height:1.5em;
  --sic-breadcrumb--default--icon-color:var(--color-primary-default);

  --sic-breadcrumb-item--default--color:var(--color-neutral-dark);
  --sic-breadcrumb-item--default--padding:var(--spacing-0);
  --sic-breadcrumb-item--default--margin:var(--spacing-0);

  --sic-breadcrumb-item-link--default--color:var(--color-neutral-dark);
  --sic-breadcrumb-item-link--default--font-size:14px;
  --sic-breadcrumb-item-link--default--font-weight:700;
  --sic-breadcrumb-item-link--default--font-family:var(--ff-body);
  --sic-breadcrumb-item-link--default--line-height:1.5em;
}
`;